import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { ACTIVE_CONVERSATION_QUERY_PARAMETER } from "@redotech/redo-merchant-support-app/query-parameters";
import { matchPath } from "react-router-dom";
import { AttachmentTest } from "../../../support-v2/components/attachment-test";
import { Support } from "../../../support-v2/support";
import { SupportHelpdesk } from "../../../support-v2/support-helpdesk";
import { ConversationsTableView } from "../../../support-v2/views/conversations-table-view";

const HIDE_PADDING_ROUTES: string[] = ["/table/*"];

function hidePadding(url: string): boolean {
  return HIDE_PADDING_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/support-v2${route}`, url),
  );
}

const FULLSCREEN_ROUTES: string[] = [];

const HIDE_HEADER_ROUTES: string[] = ["/about", ...FULLSCREEN_ROUTES];
function hideHeader(url: string, { search }: { search: string }): boolean {
  if (search.includes(ACTIVE_CONVERSATION_QUERY_PARAMETER)) {
    return true;
  }

  return HIDE_HEADER_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/support-v2${route}`, url),
  );
}

const HIDE_NAV_ROUTES: string[] = [...FULLSCREEN_ROUTES];

function hideNav(url: string): boolean {
  return HIDE_NAV_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/support-v2${route}`, url),
  );
}

export const SUPPORT_VIEW_NAME = "Support View";

export const supportV2Routes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Support-V2", breadcrumbNavigate: false },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={hideHeader}
            hideNavbar={hideNav}
            hidePadding={hidePadding}
          />
        ),
      };
    },
    children: [
      {
        element: <SupportHelpdesk />,
        children: [
          {
            handle: { breadcrumb: "Attachment Test" },
            path: "attachment-test",
            element: <AttachmentTest />,
          },
          {
            handle: { breadcrumb: SUPPORT_VIEW_NAME },
            path: ":conversationId",
            element: <Support />,
          },
          {
            handle: { breadcrumb: "Inbox" },
            path: "",
            element: <ConversationsTableView />,
          },
        ],
      },
    ],
  },
];
